const brandsData = [
    { name: 'Samsung', slug: 'brandix', image: 'assets/images/logos/logo-1.png' },
    { name: 'LG', slug: 'wakita', image: 'assets/images/logos/logo-2.png' },
    { name: 'Whirlpool', slug: 'zosch', image: 'assets/images/logos/logo-3.png' },
    { name: 'Bosch', slug: 'wevalt', image: 'assets/images/logos/logo-4.png' },
    { name: 'MI', slug: 'hammer', image: 'assets/images/logos/logo-5.png' },
    { name: 'IFB', slug: 'mitasia', image: 'assets/images/logos/logo-6.png' },
    { name: 'Carrier', slug: 'metaggo', image: 'assets/images/logos/logo-7.png' },
];

export default brandsData;
